import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table table-tenant" }
const _hoisted_6 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_7 = { colspan: "12" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }

import { ref, onMounted } from "vue";
import DocsServices from "../services/DocsServices";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UploadDocuments from "../components/DocumentsIndex/UploadDocuments.vue";
import UploadPdf from "../components/DocumentsIndex/UploadPdf.vue";
import HistoricalDocuments from "../components/DocumentsIndex/HistoricalDocuments.vue";
import AddDocuments from "../components/DocumentsIndex/AddDocuments.vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentsIndex',
  setup(__props) {

const store = useStore();
const user = store.state.AuthModule.user;
const site = ref(user.tenancy == "au" ? "ba" : user.tenancy);
const isLoading = ref(false);
const data = ref<any>([]);
const uploadDocsRef = ref<any>(null);
const uploadPdfRef = ref<any>(null);
const historicalDocsRef = ref<any>(null);
const addDocsRef = ref<any>(null);
const docsLanguages = ref<any>({});

const criteria = ref<any>({
  page: 1,
  size: 20,
  site: site.value,
});

const upload = (item: any) => {
  uploadDocsRef.value.show(item, docsLanguages.value);
};

const UploadPdfFile = (item: any) => {
  uploadPdfRef.value.show(item, docsLanguages.value);
};

const viewHistoricalData = (item: any) => {
  historicalDocsRef.value.show(item);
};

const showCreate = () => {
  addDocsRef.value.show();
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  try {
    criteria.value.page = _page;
    const res = await DocsServices.queryDocumentsList(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
    docsLanguages.value = res.languages;
  } catch (error) {
    console.log(error);
    MsgPrompt.error("Fetch data failed");
  }
  isLoading.value = false;
};

onMounted(async () => {
  await fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "success",
            onClick: showCreate,
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.create")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.documentId")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.uploadedLanguages")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.update")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(ScaleLoader, { color: '#ffc730' })
                  ])
                ])
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(item.title), 1),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.languages, (lang, key) => {
                          return (_openBlock(), _createBlock(_component_el_tag, {
                            key: key,
                            plain: "",
                            class: "ms-3",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(key), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => (upload(item)),
                          loading: isLoading.value,
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.upload")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "loading"]),
                        (_ctx.$can('SuperAdmin'))
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "success",
                              onClick: ($event: any) => (UploadPdfFile(item)),
                              plain: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.upload")) + " PDF (SuperAdmin) ", 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "warning",
                          onClick: ($event: any) => (viewHistoricalData(item)),
                          loading: isLoading.value,
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.view")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "loading"])
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ])
    ]),
    _createVNode(UploadDocuments, {
      ref_key: "uploadDocsRef",
      ref: uploadDocsRef,
      onSubmitted: _cache[0] || (_cache[0] = ($event: any) => (fetchData(1)))
    }, null, 512),
    _createVNode(UploadPdf, {
      ref_key: "uploadPdfRef",
      ref: uploadPdfRef
    }, null, 512),
    _createVNode(HistoricalDocuments, {
      ref_key: "historicalDocsRef",
      ref: historicalDocsRef
    }, null, 512),
    _createVNode(AddDocuments, {
      ref_key: "addDocsRef",
      ref: addDocsRef,
      onSubmitted: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1)))
    }, null, 512)
  ], 64))
}
}

})